import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { FaCheckCircle, FaEdit, FaTimesCircle } from 'react-icons/fa';
import SettingsTitle from '../../UIElements/SettingsTitle';
import { WEB_API_ACCOUNT_NAV } from '../../../../assets/constants/strings';
import { updateUserInfo } from '../../../../store/User/userActions';
import Loader from '../../../Loader';

const DeactivateAccount = ({ user, userError, updateUserInfo, loading }) => {
  return (
    <div id='account-info'>
      <SettingsTitle title={WEB_API_ACCOUNT_NAV.DEACTIVATE.TITLE} />
      {/* {loading ? (
        <div className='inner-load'>
          <Loader />
        </div>
      ) : ( */}
      <div className='d-flex-flex-column'>
        <p>
          Please note that deactivating your account will render all existing
          API keys inactive. This action is irreversible and will lead to the
          cessation of all associated services.
        </p>
        <button className='wf-button mt-4'>
          <b>Deactivate Account</b>
        </button>
      </div>
      {/* )} */}
    </div>
  );
};

export default DeactivateAccount;
